export { default } from './FareListTwoColumns';
